import React from 'react';
import { func, string, bool } from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ArrowRight from 'yoda-core-components/lib/assets/svg/ArrowRight.svg';
import ArrowLeft from 'yoda-core-components/lib/assets/svg/ArrowLeft.svg';
import Icon from 'yoda-core-components/lib/components/Icon/Icon/Icon';
import * as styles from './PaginationScroll.css';

const cx = classNames.bind(styles);

const PaginationScroll = ({ automationId, disableLeft, disableRight, handleScroll }) => {
    const handleScrollLeft = (e) => {
        handleScroll(true, false);
    };
    const handleScrollRight = (e) => {
        handleScroll(false, true);
    };
    return (
        <div data-automation-id={automationId} className={cx('mainContainerBlock text-center')}>
            <button
                data-automation-id="product-pagination-left"
                type="button"
                onClick={handleScrollLeft}
                className={`${dt(['m-0', 'mr-4'])}`}
            >
                <Icon
                    className={`${dt([!disableLeft ? 'text-gray-600' : 'text-gray-200'])}`}
                    height="24"
                    width="24"
                    iconType="svg"
                    data-automation-id="product-pagination-left-icon"
                >
                    <ArrowLeft />
                </Icon>
            </button>
            <button
                className="m-0 mt-3"
                data-automation-id="product-pagination-right"
                type="button"
                onClick={handleScrollRight}
            >
                <Icon
                    className={`${dt([!disableRight ? 'text-gray-600' : 'text-gray-200'])}`}
                    height="24"
                    width="24"
                    iconType="svg"
                    data-automation-id="product-pagination-right-icon"
                >
                    <ArrowRight />
                </Icon>
            </button>
        </div>
    );
};

PaginationScroll.propTypes = {
    automationId: string,
    disableLeft: bool,
    disableRight: bool,
    handleScroll: func,
};

PaginationScroll.defaultProps = {
    automationId: 'pagination-scroll',
    disableLeft: true,
    disableRight: false,
    handleScroll: () => {},
};

export default PaginationScroll;
